<script setup>
import ActionButton from '@js/components/buttons/ActionButton.vue';
import DialogModal from '@js/components/dialogs/DialogModal.vue';
import ComboboxField from '@js/components/fields/ComboboxField.vue';
import FormContent from '@js/components/forms/FormContent.vue';
import { useRoute } from '@js/utils/route';
import { ref } from 'vue';

const { modules, tenantIds, callback } = defineProps({
    modules: {
        type: Array,
        required: true,
    },
    tenantIds: {
        type: Array,
        required: true,
    },
    callback: {
        type: Function,
        required: false,
    },
});

const { route } = useRoute();

const module = ref(null);

const isOpen = ref(false);

function action() {
    axios
        .post(
            route('front.postEnableModule', {
                module: module.value.key,
            }),
            {
                tenantIds,
            },
        )
        .then(() => {
            isOpen.value = false;

            if (callback) {
                callback();
            }
        })
        .catch((error) => {
            console.error(error);
        });
}
</script>

<template>
    <DialogModal v-model="isOpen" size="small">
        <template #trigger>
            <slot name="trigger" />
        </template>

        <template #title> Activer un module </template>

        <template #content>
            <div class="min-h-96">
                <FormContent>
                    <ComboboxField
                        v-model="module"
                        :options="modules"
                        label="Module"
                        field-name="module"
                        field-id="module"
                        filteredOptionKey="fullTitle"
                    >
                        <template #optionContent="{ option }">
                            {{ option.fullTitle }}
                        </template>
                    </ComboboxField>
                </FormContent>
            </div>
        </template>

        <template #footer>
            <div class="flex justify-end gap-2">
                <ActionButton
                    type="transparent"
                    :callback="() => (isOpen = false)"
                >
                    Annuler
                </ActionButton>

                <ActionButton :callback="action"> Activer </ActionButton>
            </div>
        </template>
    </DialogModal>
</template>
